import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { CartOutlets, PromotionLocation } from '@spartacus/cart/base/root';
import { Order, OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { PromotionsComponent } from '@spartacus/storefront';
import { EfaCartItemListComponent } from '../../../shared/components/efa-cart-item-list/efa-cart-item-list.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-order-confirmation-items',
    templateUrl: './efa-order-confirmation-items.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PromotionsComponent, EfaCartItemListComponent, AsyncPipe, TranslatePipe]
})
export class EfaOrderConfirmationItemsComponent implements OnDestroy {

  readonly cartOutlets = CartOutlets;
  promotionLocation: PromotionLocation = PromotionLocation.Checkout;
  order$: Observable<Order | undefined> = this.orderFacade.getOrderDetails();

  constructor(protected orderFacade: OrderFacade) {}

  ngOnDestroy() {
    this.orderFacade.clearPlacedOrder();
  }

}
